import { CheckIcon } from "@phosphor-icons/react";
import { Fragment } from "react";
import { cn } from "@/lib/utils";
import {
  Menu,
  MenuItem,
  MenuPopover,
  MenuSeparator,
  MenuSubTrigger,
} from "./menu";

export type MenuItemConfig = {
  id: string;
  icon: React.ReactNode;
  label: string | React.ReactNode;
  onClick?: () => void;
  isDisabled?: boolean;
  className?: string;
  separator?: boolean;
  subMenu?: {
    subtitle?: string;
    items: {
      id: string;
      name: React.ReactNode;
      icon?: React.ReactNode;
      checked?: boolean;
      onItemClick?: (id: string) => void;
    }[];
    onItemClick?: (id: string) => void;
  };
  /**
   * Set up for feature flags
   */
  condition?: boolean;
};

export const CustomMenuItem = ({ config }: { config: MenuItemConfig }) => {
  // Default condition to true if not provided, only hide if explicitly false
  const shouldRender = config.condition ?? true;

  if (!shouldRender) {
    return null;
  }

  if (config.subMenu) {
    return (
      <MenuSubTrigger>
        <MenuItem className={config.className || "text-xs"}>
          {config.icon}
          <span>{config.label}</span>
        </MenuItem>
        <MenuPopover className="min-w-[154px]">
          <Menu>
            {config.subMenu.subtitle && (
              <MenuItem className={"text-[10px] font-semibold text-gray-600"}>
                {config.subMenu.subtitle}
              </MenuItem>
            )}
            {config.subMenu.items.map((item, index) => (
              <Fragment key={item.id}>
                {config.separator &&
                  config.subMenu &&
                  index === config.subMenu.items.length - 1 && (
                    <MenuSeparator className="mx-1" />
                  )}
                <MenuItem
                  className={cn("text-xs", item.checked && "pr-2")}
                  onAction={() =>
                    item.onItemClick?.(item.id) ||
                    config.subMenu?.onItemClick?.(item.id)
                  }
                >
                  {item.icon}
                  <span>{item.name}</span>
                  {item.checked && (
                    <span className="ml-auto">
                      <CheckIcon />
                    </span>
                  )}
                </MenuItem>
              </Fragment>
            ))}
          </Menu>
        </MenuPopover>
      </MenuSubTrigger>
    );
  }

  return (
    <MenuItem
      className={config.className || "text-xs"}
      onAction={config.onClick}
      isDisabled={config.isDisabled}
    >
      {config.icon}
      {config.label}
    </MenuItem>
  );
};
